const CareerPathwaysExploreLayout = <template>{{outlet}}</template>;

export default CareerPathwaysExploreLayout;
